var fcEmailOverlay = (function () {
  return {
    init: init,
  };

  function init() {
    uiBindings();
  }

  function uiBindings() {
    var fcOverlaySubmit = document.querySelector('.fc-overlay #fc-overlay-form'),
      fcOverlaySubmitBtn = document.querySelector('.fc-overlay #fc-overlay-submit'),
      emailField = document.querySelector('.fc-overlay #fc-overlay-email'),
      emailNotifyMsg = document.querySelector('.fc-overlay #email-notify-msg'),
      validEmailBool = true,
      ishomePage = document.querySelector("body#home-page");

    if (!ishomePage && !wpUserLoggedIn) {
      if (emailField) {
        emailField.addEventListener('blur', function (event) {
          event.preventDefault();
          var that = this,
            emailError = document.querySelector('.fc-overlay #error-email-span');
        
          that.dataset.notvalid = '0';

          if (emailError) {
            emailError.remove();
          }

          that.classList.remove('error-border');
          emailNotifyMsg.classList.remove('hide');

          if (that.value.trim().length == 0 || !bsLib.validEmail(that.value.trim())) {
            that.classList.add('error-border');
            emailNotifyMsg.classList.add('hide');
            emailValidationMsg(that);
          }
        });
      }
    
      if (fcOverlaySubmit) {
        fcOverlaySubmit.addEventListener('submit', function (event) {
          event.preventDefault();
          var emailError = document.querySelector('.fc-overlay #error-email-span');
          
          if (emailField) {
            if (emailError) {
              emailError.remove();
            }
            emailField.classList.remove('error-border');
            emailNotifyMsg.classList.remove('hide');
        
            if (emailField.value.trim().length == 0 || !bsLib.validEmail(emailField.value.trim())) {
              validEmailBool = false;
              emailField.classList.add('error-border');
              emailNotifyMsg.classList.add('hide');
              emailValidationMsg(emailField);
            }
        
            if (validEmailBool) {
              //disabled
              fcOverlaySubmitBtn.setAttribute('disabled', 'disabled');
        
              bsLib.ajax(
                'GET',
                bsLib.railsHost() +
                '/marketing_api/check_email_validation?email=' +
                encodeURIComponent(emailField.value) +
                '&source=paid_ads',
                {},
                true,
                {
                  'content-type': 'application/x-www-form-urlencoded; charset=utf-8', // Setting content type.
                },
                function (data) {
                  if (data.readyState === 4) {
                    var dataRequest = bsLib.JSONParse(data.response);
        
                    //remove disable
                    fcOverlaySubmitBtn.removeAttribute('disabled');
        
                    WebEventTracker.logEvent(
                      EDS.webEvents,
                      'FreshChat',
                      bsLib.extend(
                        {
                          action: 'email_submitted',
                          valid_email: dataRequest.valid,
                        },
                        popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : {}
                      )
                    );

                    if (dataRequest.valid === false) {
                      emailField.dataset.notvalid = '1';
                      emailField.classList.add('error-border');
                      emailNotifyMsg.classList.add('hide');
                      if (emailField.parentNode.getElementsByClassName('error-email-span').length === 0) {
                        emailValidationMsg(emailField);
                      }
                    } else {
                      var fcFrame = document.getElementById("fc_frame"),
                        fcOverlay = document.getElementById("fc-overlay");
                      
                      if (emailField) {
                        var userEmail = emailField.value;
                        // Set email when user:created event is triggered
                        window.fcWidget.on("user:created", function () {
                          window.fcWidget.user.setEmail(userEmail);
                        });
                      }
                      //if email verified already do not show email field overlay
                      if (fcFrame && fcOverlay) {
                        fcFrame.removeChild(fcOverlay);
                        document.body.appendChild(fcOverlay);
                      }
                      //set cookie
                      if ((Cookie.read(stage_env_cookie_prefix + 'fc_email_overlay_submitted') === '0' || Cookie.read(stage_env_cookie_prefix + 'fc_email_overlay_submitted') === null)) {
                        Cookie.create(stage_env_cookie_prefix + 'fc_email_overlay_submitted', '1', 1);
                      }
                    }
                  }
                },
                function () {}
              );
            }
          }
          return false;
        });
      }
    }
  }

  function emailValidationMsg(emailEle) {
    var emailFieldWrapper = document.querySelector('.fc-overlay #fc-overlay-email-wrapper');
    if (emailFieldWrapper) {
      emailFieldWrapper.insertAdjacentHTML(
        'afterend',
        '<span class="error-email-span" id="error-email-span"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00016 1.33333C4.32016 1.33333 1.3335 4.31999 1.3335 8C1.3335 11.68 4.32016 14.6667 8.00016 14.6667C11.6802 14.6667 14.6668 11.68 14.6668 8C14.6668 4.31999 11.6802 1.33333 8.00016 1.33333ZM8.66683 11.3333H7.3335V10H8.66683V11.3333ZM8.66683 8.66666H7.3335V4.66666H8.66683V8.66666Z" fill="#AE2727"/></svg><span class="error-message" id="email-error">' +
        (emailEle.value.trim().length == 0
          ? Messages.salesAndSupportPage.noemail
          : Messages.salesAndSupportPage.notBusinessEmail) +
        '</span></span>'
      );
    }
  }
})();

fcEmailOverlay.init();